import { useCallback, useState } from "react";
import { EMPTY_FILTER } from "../../utils/report-filter";

export const useReportFilter = (groupId) => {
  const [state, setState] = useState({ groupId, filter: EMPTY_FILTER });
  if (state.groupId !== groupId) setState({ groupId, filter: EMPTY_FILTER });
  const filter = state.groupId === groupId ? state.filter : EMPTY_FILTER;
  const setFilter = useCallback(
    (next) => setState({ groupId, filter: next }),
    [groupId],
  );
  return [filter, setFilter];
};
